import { Observable } from 'rxjs';

export class Utils {
  /**
   * Utility function to create a Key:Value from a Array of strings
   */
  static strEnum<T extends string>(o: T[]): { [K in T]: K } {
    return o.reduce((res, key) => {
      res[key] = key;

      return res;
    }, Object.create(null));
  }

  /**
   * Utility common function to track id or index on *ngFor
   */
  static trackByFn(index: any, item: any) {
    return item.value;
  }

  static isJson(data: string): boolean {
    let valid = true;

    try {
      JSON.parse(data);
    } catch {
      valid = false;
    }

    return valid;
  }

  static isXml(data: string): boolean {
    return data.indexOf('<?xml') === 0;
  }

  static isNotNullAndNotUndefined(value: any): boolean {
    return !Utils.isNullOrUndefined(value);
  }

  static unique<T>(values: T[]): T[] {
    return Array.from(new Set(values));
  }

  static capitalize(value: string): string {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  static isNullOrUndefined(value: any) {
    return value === null || value === undefined;
  }

  static getBase64 = (file: File): Promise<string | ArrayBuffer | null> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });

  static mapper(rawData: any, mapping: { [x: string]: string }) {
    return Object.keys(mapping).reduce((acc: any, key) => {
      acc[mapping[key]] = rawData[key];
      return acc;
    }, {});
  }

  static readFile(blob: Blob): Observable<string> {
    return Observable.create((obs: any) => {
      const reader = new FileReader();

      reader.onerror = err => obs.error(err);
      reader.onabort = err => obs.error(err);
      reader.onload = () => obs.next(reader.result);
      reader.onloadend = () => obs.complete();

      return reader.readAsDataURL(blob);
    });
  }

  static groupBy<T, K extends keyof any>(list: T[], getKey: (item: T) => K): Record<K, T[]> {
    return list.reduce((previous, currentItem) => {
      const group = getKey(currentItem);
      if (!previous[group]) {
        previous[group] = [];
      }
      previous[group].push(currentItem);
      return previous;
    }, {} as Record<K, T[]>);
  }
}
